export const getToolbarStyles = (_, { palette = {} }) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  item: {
    display: 'flex',
    flexDirection: 'row',
    color: '#ffffff',
    '& .ms-Button': {
      color: 'inherit !important',
      '&:hover': {
        cursor: 'pointer',
        backgroundColor: 'rgba(0, 0, 0, .1)',
        textDecoration: 'none',
        color: 'inherit !important',
      },
      '&:active': {
        backgroundColor: 'rgba(0, 0, 0, .2)',
        textDecoration: 'none',
      },
      '&:focus': {
        textDecoration: 'none',
        color: `${palette.neutralPrimary} !important`,
      },
    },
  },
  strench: {
    width: '100%',
  },
  verticalLine: {
    borderLeftColor: '#ffffff',
    borderLeftWidth: 1,
    borderLeftStyle: 'solid',
    height: 40,
    marginTop: 10,
    marginBottom: 10,
    marginLeft: 8,
    marginRight: 8,
  },
});
